module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAAgUlEQVRYR+3W2wmAMABD0esWOpKuIbiV4/kYQ0RFEH+DFm4HKOE00FRAC4xAw7/PAvQVMBcQ9qJcSgu87oG7sxL1vxvBBAx74KKOgdPPpbDCDwErYSWsRLoDL8LOyyC68zKI67xM4t53+zWnnRVW2PGT7oDCHwg7L4Pozssg7jEvN4KfGUOQNiCrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/assets/hot.png
// module id = JqSz
// module chunks = 2